<template>
	<div class="receipt">
		<div class="search">
            <el-row class="clear">
                <label> 入荷指示id:</label><el-input class="search-input" @keyup.enter.native="query" clearable v-model="q.adoption_id" placeholder="请输入入荷指示id"></el-input>
                <el-button class="search-button" type="primary" @click="query">搜索</el-button>
            </el-row>
        </div>
		<el-table
			:data="receiptList"
			style="width: 100%"
			border
			stripe
			@expand-change="load2Children"
			v-loading="receiptLoading"
			ref="receiptTable"
		>
			<el-table-column type="expand">
				<!-- 二级 -->
				<template slot-scope="scope">
					<el-table
						v-if="!isShowMakeupList"
						:data="receiptDetail[scope.row.id]"
						style="width: 100%"
						v-loading="receiptDetailLoading"
						@expand-change="load3Children"
					>
						<el-table-column type="expand">
							<!-- 三级 -->
							<template slot-scope="scope">
								<el-table
									:data="inbounds[scope.row.receipt_id]"
									v-loading="inboundsLoading"
									style="width: 100%"
								>
									<el-table-column
										prop="id"
										label="id"
										width="180"
									/>
									<el-table-column
										prop="arrival_count"
										label="实入"
									/>
									<el-table-column
										prop="optime"
										label="操作时间"
									/>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column
							prop="jancode"
							label="jancode"
							width="180"
						/>
						<el-table-column
							prop="demand_count"
							label="应入"
							width="180"
						/>
						<el-table-column
							prop="arrival_count"
							label="实入"
						/>
            <el-table-column
	            prop="abandon_count"
	            label="丢弃"
            />
					</el-table>
					<div v-else>补货列表</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="id"
				label="订单号"
				width="180"
			/>
			<el-table-column
				prop="house_id"
				label="仓库"
				width="180"
			/>
			<el-table-column
				prop="adoption_id"
				label="入荷指示id"
			/>
      <el-table-column
				prop="status"
				label="状态"
			/>
			<el-table-column label="操作" width="300">
				<template slot-scope="scope">
					<el-button
						size="mini"
						type="success"
						v-show="scope.row.status < 4"
						@click="makeUp(scope.row)">结单</el-button>
					<!-- <el-button
						size="mini"
						type="info"
						@click="handleMakeupList(scope.row)">补货列表</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="currentPage"
			layout="total, prev, pager, next, jumper"
			:total="total"
		/>
		<el-dialog title="结单" :visible.sync="dialogFormVisible">
			<el-table :data="goods">
				<el-table-column property="jancode" label="jancode" width="150"></el-table-column>
				<el-table-column property="should_makeup_count" label="应补" width="50"></el-table-column>
        <el-table-column label="丢弃数量" width="150">
	        <template slot-scope="scope">
            <el-input-number
							size="mini"
							:max="scope.row.max"
							v-model="scope.row.abandon_count"></el-input-number>
	        </template>
        </el-table-column>
				<el-table-column label="补货数量" width="150">
					<template slot-scope="scope">
						<el-input-number
							size="mini"
							:max="scope.row.max"
							v-model="scope.row.makeup_count"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column property="profit_count" label="盘亏数量" width="150"></el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleMakeup">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			currentPage: 1,
			receiptList: [],
			receiptDetail: {},
			inbounds: {},
			total: 0,
			page_count: 1,
			q: {},
			isShowMakeupList: false,
			isShowOtherList: true,
			dialogFormVisible: false,
			goods: [],
			receiptLoading: false,
			receiptDetailLoading: false,
			inboundsLoading: false,
			count: 0
		};
	},
	created() {
		this.getReceiptList();
	},
	methods: {
		handelCountChange(val) {

		},
		getReceiptList() {
			this.receiptLoading = true;
			this.$axios.receipt.getList(this.currentPage).then(res => {
				this.receiptList = res.data.list;
				this.total = res.data.total;
				this.receiptLoading = false;
			});
		},
		makeUp(row) {
			this.$axios.receipt.checkReceipt(row.id).then(res => {
			  let _goods = res.data
        if (Object.keys(res.data).length > 0) {
          this.dialogFormVisible = true;
          this.goods = [];
          for (var jancode in _goods) {
            this.goods.push({
              receipt_id: row.id,
              jancode: jancode,
              should_makeup_count: _goods[jancode],
              makeup_count: _goods[jancode],
              abandon_count: 0,
              profit_count: 0
            });
          }
        } else {
          this.$axios.receipt.terminateReceipt(row.id, {}).then(res => {
            this.getReceiptList();
          });
        }
			});
		},
		handleSizeChange() {

		},
		handleCurrentChange(current_page) {
			this.currentPage = current_page;
			this.getReceiptList();
		},
		load2Children(row, expanded) {
			this.receiptDetailLoading = true;
			this.isShowMakeupList = expanded.length > 0 && this.isShowMakeupList;
			this.$axios.receipt.getReceiptDetail(row.id).then(res => {
				this.receiptDetail[row.id] = res.data;
				this.receiptDetailLoading = false;
			});
		},
		load3Children(row, expanded) {
			this.inboundsLoading = true;
			this.$axios.receipt.getInbounds(row.receipt_id, row.id).then(res => {
				this.inbounds[row.receipt_id] = res.data;
				this.inboundsLoading = false;
			});
		},
		handleFinish(index, row) {
			this.$confirm('结单后不能补货，是否确认？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$axios.receipt.finishReceipt(row.id).then(res => {
					this.getReceiptList();
				});
			}).catch(() => {

			});

		},
		handleMakeup() {
			let id = this.goods[0].receipt_id;
			let params = {};
			let goodsList = [];
			params.receipt_id = id;
			params.goods = this.goods;
			this.$axios.receipt.terminateReceipt(id, params).then(res => {
				this.getReceiptList();
				this.dialogFormVisible = false;
			});
		},
		handleMakeupList(row) {
			this.isShowMakeupList = true;
			this.$refs.receiptTable.toggleRowExpansion(row, true);
		},
		query() {
			if(!this.q.adoption_id) {
				this.getReceiptList();
				return false;
			}
			this.$axios.receipt.search(this.q.adoption_id).then(res => {
				if(!res.code && res.data) {
					this.receiptList = [res.data];
					this.total = this.receiptList.length;
				} else {
					this.receiptList = [];
					this.total = 0;
				}
			});
		}
	}
};
</script>

<style>
	.el-pagination {
		margin-top: 20px;
	}
	.search {
		text-align: left;
		height: 64px;
	}
	.search .el-input {
		max-width: 200px;
		margin: 0 20px;
	}
</style>


